import { useQuery } from '@tanstack/react-query';
import { DEFAULT_GC_TIME } from '@/client/constants';
import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { BackendsData } from '@/client/types/ai-management';
import { aiKeys, unwrapEnvelope } from './overview.query';

export const BACKENDS = '/llm-admin/backends';

const useBackendsFn = () => {
  const request = useClientStore((s) => s.request);
  return withErrorHandling(async (): Promise<BackendsData> => {
    const raw = await request<any>(BACKENDS);
    return unwrapEnvelope<BackendsData>(raw);
  }, 'Failed to load backend fleet');
};

export const useBackendsQuery = (enabled = true) => {
  const queryFn = useBackendsFn();
  return useQuery({
    queryKey: aiKeys.backends(),
    queryFn,
    enabled,
    // The poller ticks every 15s, so anything shorter just re-renders the
    // same measurement.
    staleTime: 1000 * 15,
    refetchInterval: 1000 * 30,
    gcTime: DEFAULT_GC_TIME,
  });
};
